import { Observable } from 'rxjs';
import {
  AssistantChatBlock,
  AssistantChatMessage,
  AssistantChatPrompt,
  AssistantChatReply,
} from '../../interfaces/assistant-chat.interface';

export abstract class AssistantChatResponder {
  public abstract ask(
    prompt: AssistantChatPrompt,
    thread: AssistantChatMessage[],
  ): Observable<AssistantChatBlock[] | AssistantChatReply>;
}
